import { call, put, takeEvery } from 'redux-saga/effects';
import {
  importFromFile,
  setImportResponse,
  setIsImporterLoading,
} from './actions';
import { PRODUCT_GROUP_ASSOCIATIONS_URL, PRODUCTS_URL } from '../../config';
import getUrlFiltered from '../../utils/helper_functions/getUrlFiltered';
import { setLoader } from '../loader/actions';
import history from '../../utils/helper_functions/history';

const importDestination = (destination) => {
  switch (destination) {
    case 'associations':
      return PRODUCT_GROUP_ASSOCIATIONS_URL;
    default:
      return PRODUCTS_URL;
  }
};

export function* importFromFileSaga(action) {
  yield put(setLoader('fileImporter', true));

  const formData = new FormData();
  formData.append('file', action.payload.file);

  yield put(setIsImporterLoading(true));

  yield put(setImportResponse({
    fileUploaded: null,
    violations: [],
    records: {},
  }));

  const response = yield call(fetch, getUrlFiltered(`${importDestination(action.payload.destination)}/import`), {
    method: 'POST',
    body: formData,
  });

  const data = yield response.json();
  switch (response.status) {
    case 200:
      yield put(setImportResponse({
        fileUploaded: response.status,
        records: data,
        violations: [],
      }));
      break;
    case 500:
      yield call(history.push, '/500');
      break;

    default:
      yield put(setImportResponse({
        fileUploaded: response.status,
        violations: data.violations,
        records: {},
      }));
  }

  yield put(setIsImporterLoading(false));
  yield put(setLoader('fileImporter', false));
}

export function* watchFetchImportFromFileSaga() {
  yield takeEvery(String(importFromFile), importFromFileSaga);
}
